module.exports = __webpack_public_path__ + "images/emoji/1234.d51c6150155da54b8a1c.png";